
  Vue.component('seekers-relationships-manager', {
    props: {
      visible: { type: Boolean, default: true }
    },
    data() {
      return {
        currentPage: 1,
        formInterfaces: {},
        pageflow: '',
        contactList: [],
        newContactId: null,
        defaultFieldValue: {},
        relationshipType: null,
        broadcastUrl: null
      }
    },
    template: '#seekers-relationships-manager',
    computed: {
      pages() {
        const retVal = [
          {
            id: 10,
            code: 'nuovo',
            label: 'Invia richiesta',
            title: `Invita un'azienda`,
            subTitle: `ad entrare nella tua rete`,
            titleIcon: 'fa-users-medical fa-swap-opacity'
          },
          {
            id: 20,
            code: 'elenco',
            label: 'I tuoi contatti',
            title: 'Gestisci i tuoi contatti',
            subTitle: 'Controlla lo stato dei tuoi inviti ',
            titleIcon: 'fa-users-cog'
          },
          {
            id: 30,
            code: 'condividi',
            label: 'Condividi',
            title: `Condividi`,
            subTitle: `Pubblica sui social o invia il link a tutti i tuoi partner.`,
            titleIcon: 'fa-broadcast-tower fa-swap-opacity'
          }
        ]
        return retVal.sort((a, b) => (a.id > b.id ? 1 : -1))
      },
      currentPageCode() {
        return this.pages[this.currentPage - 1].code
      }
    },
    watch: {},
    methods: {
      nextPage(e, pageNumber) {
        if (this.currentPage < this.pages.length) {
          this.pageflow = ''
          if (pageNumber) {
            setTimeout(() => (this.currentPage = pageNumber), 100)
          } else {
            setTimeout(() => this.currentPage++, 100)
          }
        } else {
          console.log('Ultima Pagina')
        }
      },
      previousPage(e, pageNumber) {
        this.pageflow = '-back'
        if (pageNumber) {
          setTimeout(() => (this.currentPage = pageNumber), 100)
        } else if (this.currentPage > 1) {
          setTimeout(() => this.currentPage--, 100)
        }
      },
      stopAll(event) {
        event.stopPropagation()
        event.preventDefault()
        return false
      },
      beforeEnter: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      },
      getErrorResponse(error) {
        console.log(error)
        let retVal = error
        if (error.response) {
          retVal = { status: error.response.status }
          if (error.response.data && error.response.data.error) {
            retVal = {
              ...retVal,
              ...error.response.data.error
            }
          }
        }
        return retVal
      },
      sendRequest() {
        const key = 'ContactRequest'
        const self = this
        if (this.formInterfaces[key].validate()) {
          if (!this.formInterfaces[key].fieldsAreChange()) {
            self.nextPage()
          } else if (this.formInterfaces[key].fieldsAreChange()) {
            const formValue = self.formInterfaces[key].getValues()

            axios
              .post(`/api/v1/seekers-relationships/new`, formValue)
              .then(response => {
                const { data } = response
                self.newContactId = data.Id
                EventBus.$emit('vnShow', {
                  type: 'success',
                  message: `l'invito è stato spedito correttamente`
                })
                self.nextPage()
              })
              .catch(error => {
                const errorResponse = self.getErrorResponse(error)
                if (errorResponse.status == 401) {
                  self.handleSessionExpired()
                } else if (errorResponse.isCandidate) {
                  EventBus.$emit('vnPopup', {
                    message: `<p><b>Questo indirizzo eMail è già utilizzato da un candidato.</b></p><p class="mt-2">Non è possibile invitare utenti già registrati come candidati.</p> `,
                    actions: [{ label: 'Ok', icon: 'fa-check', style: 'info' }]
                  })
                } else if (errorResponse.alreadyInvited) {
                  EventBus.$emit('vnPopup', {
                    message: `<p><b>Questo contatto è già stato invitato.</b></p><p class="mt-2">Vuoi spedire un nuovo invito.</p> `,
                    actions: [
                      {
                        label: 'OK',
                        icon: 'fa-check-circle',
                        action: () => {
                          self.newContactId = errorResponse.id
                          self.reSend(event, errorResponse.id)
                        },
                        style: 'success'
                      },
                      { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
                    ]
                  })
                } else {
                  EventBus.$emit('vnShow', {
                    type: 'danger',
                    message: `Le modifiche non sono state salvate: ${error}`
                  })
                }
              })
              .then(() => {
                // always executed
              })
          }
        }
      },
      reSend(event, id) {
        const self = this
        axios
          .get(`/api/v1/seekers-relationships/resend/${id}`)
          .then(response => {
            const { data } = response
            self.nextPage(null, 1)

            EventBus.$emit('vnShow', {
              type: 'success',
              message: `L'invito è stato spedito correttamente.`
            })
          })
          .catch(error => {
            const errorResponse = self.getErrorResponse(error)
            if (errorResponse.status == 401) {
              self.handleSessionExpired()
            } else {
              EventBus.$emit('vnShow', {
                type: 'danger',
                message: `L'invio non è stato spedito: ${error}`
              })
            }
          })
          .then(() => {
            // always executed
          })
      },
      getDefault() {
        const self = this
        axios
          .get(`/api/v1/seekers-relationships/seekerdefault/`)
          .then(response => {
            const { data } = response

            self.relationshipType = data.relationshipType
            self.defaultFieldValue = { ...self.defaultFieldValue, ContactMessage: data.defaultMessage }
            self.broadcastUrl = data.broadcastUrl

            console.log(self.defaultFieldValue)
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      handleSessionExpired() {
        EventBus.$emit('vnPopup', {
          type: 'danger',
          message: `<p><b>La sessione è scaduta</b></p><p>La pagina verrà ricaricata per permettere di effettuare nuovamente il login</p>`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                window.location.reload()
              },
              style: 'danger'
            }
          ]
        })
      }
    },
    mounted() {
      this.getDefault()
      // EventBus.$on('vnShow', this.vnShow)
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
